export default "__VITE_ASSET__DyFFaHKY__"